import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, ClipboardCheckIcon, ShirtIcon, UsersIcon } from 'lucide-react';
const benefits = [{
  icon: MapPinIcon,
  title: 'Asignación por zona',
  description: 'Servicios asignados según tu zona y disponibilidad para optimizar tu tiempo'
}, {
  icon: ClipboardCheckIcon,
  title: 'Estándares de calidad',
  description: 'Checklist y protocolos claros para garantizar trabajos de excelencia'
}, {
  icon: ShirtIcon,
  title: 'Imagen profesional',
  description: 'Camisa JAZUGAS para representar la marca líder en Costa Rica'
}, {
  icon: UsersIcon,
  title: 'Coordinación clara',
  description: 'Relación por servicios con seguimiento y comunicación constante'
}];
export function ValueProposition() {
  return <section className="w-full bg-gradient-to-br from-jazugas-blue to-blue-900 py-20 px-4" data-id="element-42">
      <div className="max-w-6xl mx-auto" data-id="element-43">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-white text-center mb-4" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-44">
          ¿Qué Ofrecemos?
        </motion.h2>
        <motion.p className="text-lg text-blue-100 text-center mb-16 max-w-2xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-45">
          Trabajá con la empresa líder en gas LP de Costa Rica
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-46">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300" initial={{
            opacity: 0,
            x: index % 2 === 0 ? -30 : 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} data-id="element-47">
                <div className="flex items-start space-x-4" data-id="element-48">
                  <div className="w-14 h-14 bg-jazugas-yellow rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-49">
                    <Icon className="w-7 h-7 text-jazugas-black" aria-hidden="true" data-id="element-50" />
                  </div>
                  <div data-id="element-51">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-52">
                      {benefit.title}
                    </h3>
                    <p className="text-blue-100 leading-relaxed" data-id="element-53">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}